// src/modules/IntegratedMessaging/adapters/CouriersApiAdapter.ts
import { HttpClient } from '@adapters/HttpClient';
import { Courier } from '../models/IntegratedMessaging';

export class CouriersApiAdapter {
  constructor(private httpClient: HttpClient) {}

  /**
   * Devuelve la lista de couriers disponibles
   */
  async getCouriers(): Promise<Courier[]> {
    // adaptamos al shape que devuelve el backend: { data: Courier[] }
    const response = await this.httpClient.get<{ data: Courier[] }>(
      '/couriers'
    );
    return response.data;
  }
}
